import React, { useState, useEffect } from "react";
import { Backdrop, CircularProgress, Button } from "@mui/material";
import LoginHeader from "./components/LoginHeader.js";
import SideNavigation from "./components/SideNavigation.js";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AADHeader from "./components/AADHeader.js";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "primereact/dropdown";
import { DatePicker } from "antd";
import { BiSolidCalendar } from "react-icons/bi";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode } from "primereact/api";
import "./table.css";

const InternalReports = () => {
  const navigate = useNavigate();

  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768);
  const [loading, setLoading] = useState(false);
  const [expandedRows, setExpandedRows] = useState(null);
  const [formData, setFormData] = useState({
    legalEntity: null,
    site: null,
    esgParameter: null,
    fromDate: null,
    toDate: null,
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    site: { value: null, matchMode: FilterMatchMode.CONTAINS },
    fromDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
    toDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
    electricityConsumption: { value: null, matchMode: FilterMatchMode.CONTAINS },
    emissionFactor: { value: null, matchMode: FilterMatchMode.CONTAINS },
    emissionFactorSource: { value: null, matchMode: FilterMatchMode.CONTAINS },
    marketBasedEmissions: { value: null, matchMode: FilterMatchMode.CONTAINS },
    locationBasedEmissions: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    setFilters((prevFilters) => ({
      ...prevFilters,
      global: { value: value, matchMode: FilterMatchMode.CONTAINS },
    }));
    setGlobalFilterValue(value);
  };

  const [data, setData] = useState([
    {
      site: "Bangalore",
      fromDate: "2024-01-01",
      toDate: "2024-12-31",
      electricityConsumption: "5000 Mwh",
      emissionFactor: "0.8",
      emissionFactorSource: "Source A",
      marketBasedEmissions: "4000",
      locationBasedEmissions: "4500",
      details: [
        { site: "Bangalore", fromDate: "2024-01-01", toDate: "2024-03-31", electricityConsumption: "1200 Mwh", emissionFactor: "0.8", emissionFactorSource: "Source A", marketBasedEmissions: "960", locationBasedEmissions: "1080" },
        { site: "Bangalore", fromDate: "2024-04-01", toDate: "2024-06-30", electricityConsumption: "1300 Mwh", emissionFactor: "0.8", emissionFactorSource: "Source A", marketBasedEmissions: "1040", locationBasedEmissions: "1170" },
      ],
    },
    {
      site: "Delhi",
      fromDate: "2024-01-01",
      toDate: "2024-12-31",
      electricityConsumption: "4000 Mwh",
      emissionFactor: "0.7",
      emissionFactorSource: "Source B",
      marketBasedEmissions: "2800",
      locationBasedEmissions: "3200",
      details: [
        { site: "Delhi", fromDate: "2024-01-01", toDate: "2024-03-31", electricityConsumption: "1000 Mwh", emissionFactor: "0.7", emissionFactorSource: "Source B", marketBasedEmissions: "700", locationBasedEmissions: "800" },
        { site: "Delhi", fromDate: "2024-04-01", toDate: "2024-06-30", electricityConsumption: "1100 Mwh", emissionFactor: "0.7", emissionFactorSource: "Source B", marketBasedEmissions: "770", locationBasedEmissions: "880" },
      ],
    },
  ]);

  const totalValues = data.reduce(
    (acc, row) => {
      acc.electricityConsumption += row.electricityConsumption;
      acc.marketBasedEmissions += row.marketBasedEmissions;
      acc.locationBasedEmissions += row.locationBasedEmissions;
      return acc;
    },
    { electricityConsumption: 0, marketBasedEmissions: 0, locationBasedEmissions: 0 }
  );

  const legalEntityOptions = [
    { label: "Entity 1", value: "entity1" },
    { label: "Entity 2", value: "entity2" },
  ];

  const siteOptions = [
    { label: "Site A", value: "siteA" },
    { label: "Site B", value: "siteB" },
  ];

  const esgOptions = [
    { label: "Carbon Footprint", value: "carbon" },
    { label: "Water Usage", value: "water" },
  ];

  const handleChange = (e, field) => {
    setFormData((prev) => ({ ...prev, [field]: e.value }));
  };

  const handleDateChange = (date, field) => {
    setFormData((prev) => ({ ...prev, [field]: date }));
  };

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false);
      } else {
        setIsSidebarOpen(true);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const renderHeader = () => {
    const loginType = localStorage.getItem("loginType");
    if (loginType === "AAD") {
      return <AADHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
    }
    return <LoginHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
  };

  return (
    <div id="wrapper">
      <div>
        {loading && (
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </div>
      {renderHeader()}
      <SideNavigation isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div id="page-content-wrapper" className={isSidebarOpen ? "page-content-wrapper-pd-0" : "page-wrapper"}>
        <div className="container formpd scf esg-dashboard">
          <div className="flex justify-content-between">
            <div className="steps__containt-hader">
              <h1 className="title">Internal reports</h1>
              <div role="presentation">
                <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                  <Typography color="text.primary">Reports</Typography>
                  <Typography color="text.primary">Internal</Typography>
                </Breadcrumbs>
              </div>
            </div>
          </div>
          <div className="scf survey-form internal-reports">
            <div className="form-part">
              <form>
                <div className="row gx-2">
                  <div className="col-xl-2 col-lg-4 col-md-6">
                    <label className="formlable" htmlFor="legalEntity">
                      Legal Entity
                    </label>
                    <Dropdown id="legalEntity" className="form-control wd-100" value={formData.legalEntity} options={legalEntityOptions} onChange={(e) => handleChange(e, "legalEntity")} placeholder="Select" />
                  </div>

                  <div className="col-xl-2 col-lg-4 col-md-6">
                    <label className="formlable" htmlFor="site">
                      Site
                    </label>
                    <Dropdown id="site" className="form-control wd-100" value={formData.site} options={siteOptions} onChange={(e) => handleChange(e, "site")} placeholder="Select" />
                  </div>
                  <div className="col-xl-2 col-lg-4 col-md-6">
                    <label className="formlable" htmlFor="fromDate">
                      From Date
                    </label>
                    <DatePicker
                      id="fromDate"
                      value={formData.fromDate}
                      onChange={(date) => handleDateChange(date, "fromDate")}
                      className="calendar-form form-control"
                      placeholder="From"
                      format="YYYY-MM-DD"
                      suffixIcon={<BiSolidCalendar />}
                    />
                  </div>

                  <div className="col-xl-2 col-lg-4 col-md-6">
                    <label className="formlable" htmlFor="toDate">
                      To Date
                    </label>
                    <DatePicker
                      id="toDate"
                      value={formData.toDate}
                      onChange={(date) => handleDateChange(date, "toDate")}
                      className="calendar-form form-control"
                      placeholder="To"
                      format="YYYY-MM-DD"
                      suffixIcon={<BiSolidCalendar />}
                      disabledDate={(current) => current && current < formData.fromDate}
                    />
                  </div>
                  <div className="col-xl-2 col-lg-4 col-md-6">
                    <label className="formlable" htmlFor="esgParameter">
                      ESG Parameter
                    </label>
                    <Dropdown id="esgParameter" className="form-control wd-100" value={formData.esgParameter} options={esgOptions} onChange={(e) => handleChange(e, "esgParameter")} placeholder="Select" />
                  </div>
                </div>
                <h2 className="eco-h2">Summary</h2>
                <div className="row">
                  <div className="col-md-8">
                    <table className="summary-table">
                      <thead>
                        <tr>
                          <th>Electricity Consumption</th>
                          <th>Market Based Emissions</th>
                          <th>Location Based Emissions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colSpan="3">
                            Total: {totalValues.electricityConsumption + totalValues.marketBasedEmissions + totalValues.locationBasedEmissions}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <h2 className="eco-h2">Details</h2>
                <DataTable
                  value={data}
                  paginator
                  rows={10}
                  rowsPerPageOptions={[10, 20, 25, 50]}
                  scrollable
                  scrollDirection="horizontal"
                  tableStyle={{ minWidth: "70rem" }}
                  paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                  currentPageReportTemplate="{first} to {last} of {totalRecords}"
                  globalFilterFields={["site", "fromDate", "toDate", "electricityConsumption", "emissionFactor", "emissionFactorSource", "marketBasedEmissions", "locationBasedEmissions"]}
                  filters={filters}
                  filterDisplay="row"
                  expandedRows={expandedRows}
                  onRowToggle={(e) => setExpandedRows(e.data)}
                  onRowClick={(e) => setExpandedRows(expandedRows?.includes(e.data) ? null : [e.data])}
                  rowClassName={() => "clickable-row"}
                  rowExpansionTemplate={(rowData) => (
                    <DataTable value={rowData.details} showHeaders={false}>
                      <Column field="site" style={{ width: "12.5%" }} />
                      <Column field="fromDate" style={{ width: "12.5%" }} />
                      <Column field="toDate" style={{ width: "12.5%" }} />
                      <Column field="electricityConsumption" style={{ width: "12.5%" }} />
                      <Column field="emissionFactor" style={{ width: "12.5%", paddingLeft: "15px" }} />
                      <Column field="emissionFactorSource" style={{ width: "12.5%", paddingLeft: "15px" }} />
                      <Column field="marketBasedEmissions" style={{ width: "12.5%", paddingLeft: "15px" }} />
                      <Column field="locationBasedEmissions" style={{ width: "12.5%", paddingLeft: "15px" }} />
                    </DataTable>
                  )}
                >
                  <Column field="site" header="Site" sortable filter filterPlaceholder="Filter" style={{ width: "12.5%", paddingLeft: "15px" }} />
                  <Column field="fromDate" header="From Date" sortable filter filterPlaceholder="Filter" style={{ width: "12.5%", paddingLeft: "15px" }} />
                  <Column field="toDate" header="To Date" sortable filter filterPlaceholder="Filter" style={{ width: "12.5%", paddingLeft: "15px" }} />
                  <Column field="electricityConsumption" header="Electricity Consumption (Mwh)" sortable filter filterPlaceholder="Filter" style={{ width: "12.5%", paddingLeft: "15px" }} />
                  <Column field="emissionFactor" header="Emission Factor" sortable filter filterPlaceholder="Filter" style={{ width: "12.5%" }} />
                  <Column field="emissionFactorSource" header="Emission Factor Source" sortable filter filterPlaceholder="Filter" style={{ width: "12.5%" }} />
                  <Column field="marketBasedEmissions" header="Market Based Emissions" sortable filter filterPlaceholder="Filter" style={{ width: "12.5%" }} />
                  <Column field="locationBasedEmissions" header="Location Based Emissions" sortable filter filterPlaceholder="Filter" style={{ width: "12.5%" }} />
                </DataTable>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InternalReports;
